var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader_wrap"},[_c('div',{staticClass:"loader_inner"},[_c('div',{staticClass:"loader_ring"},[_c('div',{staticClass:"loader_ring-inner",style:('border-color: ' +
          _vm.user.config.parameters.parameters.colorprimary +
          ' transparent ' +
          _vm.user.config.parameters.parameters.colorprimary +
          ' transparent;')})])])])}
var staticRenderFns = []

export { render, staticRenderFns }